import { render } from "./VrPlayer.vue?vue&type=template&id=2ee13cc6"
import script from "./VrPlayer.vue?vue&type=script&lang=js"
export * from "./VrPlayer.vue?vue&type=script&lang=js"

import "./VrPlayer.vue?vue&type=style&index=0&id=2ee13cc6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__